import Entity from '../entity'
import UserPointDetail from './UserPointDetail';

export default class PointType extends Entity<number>{
    name: string  = null;
    displayName: string  = null;
    tenantId: number  = null;
    remark: string  = null;
    userPointDetails: Array<UserPointDetail>;
}